import AttachmentsList from '@app/components/AttachmentsList'
import PageSection from '@app/components/PageSection'
import PhotoStrip from '@app/components/PhotoStrip'
import SearchBar from '@app/components/SearchBar'
import { bindFunctions } from '@app/utils/class'
import { filterAttachments } from '@app/utils/filters'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {
  actionCreators,
  IAssignmentDetailState,
} from '../modules/assignmentDetail'

type AssignmentFilesProps = IAssignmentDetailState &
  RouteComponentProps<{}> &
  typeof actionCreators

interface IAssignmentFilesState {
  filterText: string
}

class AssignmentFiles extends React.PureComponent<
  AssignmentFilesProps,
  IAssignmentFilesState
> {
  constructor(props: AssignmentFilesProps) {
    super(props)

    this.state = {
      filterText: '',
    }

    bindFunctions(this)
  }

  public render() {
    const filteredAttachments = this.state.filterText
      ? this.props.item.attachments
          .filter(filterAttachments(this.state.filterText))
          .toList()
      : this.props.item.attachments

    return (
      <DocumentTitle title={`${this.props.item.title} :: Files`}>
        <div className='mb-3'>
          {this._renderPhotos()}
          {this._renderAttachments()}
        </div>
      </DocumentTitle>
    )
  }

  private _renderAttachments() {
    const filterFunc = this.state.filterText
      ? filterAttachments(this.state.filterText)
      : undefined

    const filteredAttachments = this.state.filterText
      ? this.props.item.attachments
          .filter(filterAttachments(this.state.filterText))
          .toList()
      : this.props.item.attachments

    const relatedAttachments = this.props.item.relatedAttachments
      .toArray()
      .filter((item) => item.attachments.size > 0)
      .map((item) => {
        const attachments = filterFunc
          ? item.attachments.filter(filterFunc).toList()
          : item.attachments

        if (attachments.size === 0) {
          return null
        }

        return (
          <div className='mt-4' key={item.referenceId}>
            <h6>From {item.name}</h6>
            <AttachmentsList
              attachments={attachments}
              noFilter
              noSort
              onChange={(e) =>
                this.props.setRelatedAttachments(e, item.referenceId)
              }
              propertyId={item.referenceId}
            />
          </div>
        )
      })

    return (
      <PageSection className='mt-5' title='Attachments'>
        <div className='mb-3'>
          <SearchBar
            onChange={(newFilter) => this.setState({ filterText: newFilter })}
            placeholder='Filter attachments...'
            size='sm'
            value={this.state.filterText}
          />
        </div>
        <AttachmentsList
          attachments={filteredAttachments}
          onChange={this.props.setAttachments}
          noFilter
          noSort
        />
        {relatedAttachments}
      </PageSection>
    )
  }

  private _renderPhotos() {
    const relatedPhotos = this.props.item.relatedAttachments
      .toArray()
      .filter((item) => item.photos.size > 0)
      .map((item) => (
        <div className='mt-4' key={item.referenceId}>
          <h6>From {item.name}</h6>
          <PhotoStrip photos={item.photos} propertyId={item.referenceId} />
        </div>
      ))

    return (
      <PageSection title='Photos'>
        <PhotoStrip photos={this.props.item.attachments} />
        {relatedPhotos}
      </PageSection>
    )
  }
}

export default withRouter(AssignmentFiles)
